export default {
   order_details: [],
   promotion_details:[],
   started_at: null,
   last_updated_at: null,
   order_notes: null,
   amounts: {
      subtotal: 0,
      ieps: 0,
      iva: 0,
      tax: 0,
      after_tax_total: 0,
      discount: 0,
      final_total: 0,
   },
   promo_amounts: {
      subtotal: 0,
      subtotal_order_lines: 0,
      ieps: 0,
      iva: 0,
      tax: 0,
      after_tax_total: 0,
      discount: 0,
      final_total: 0,
   },
   units: {
      pieces: 0,
      boxes: 0,
   }
}
